export default "__VITE_ASSET__Z1Mx8ZBj__"